import { PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/parts_equipments_work_orders_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'partsEquipmentsWorkordersIndex',
	'workOrderAddedPartsIndex',
	'workOrderAddedEPSLIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
